import { render, staticRenderFns } from "./call-dialog.vue?vue&type=template&id=37dedb19&scoped=true"
import script from "./call-dialog.vue?vue&type=script&lang=js"
export * from "./call-dialog.vue?vue&type=script&lang=js"
import style0 from "./call-dialog.vue?vue&type=style&index=0&id=37dedb19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dedb19",
  null
  
)

export default component.exports